<template>
  <div class="tugas">
    <div class="header">
      <h3>Notifikasi</h3>
    </div>

    <div class="body">
      <ul>
        <li v-for="(item, index) in data" :key="index">
          <div>
            <p>
              <b>{{ item.judul }}</b> <br />
              {{ item.keterangan }}
            </p>
          </div>
          <div>
            <small>{{
              moment(item.created_at).format("DD/MM/YY HH:mm")
            }}</small>
          </div>
        </li>
      </ul>

      <p
        v-show="data.length <= 0"
        style="text-align: center; font-size: 15px; padding: 100px 0"
      >
        Tidak ada notifikasi
      </p>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import * as api from "../api/Api";

import Loading from "./icons/Loading";
import Back from "./icons/Back.vue";

export default {
  name: "Task",
  components: {
    Back,
    Loading,
  },
  data() {
    return {
      data: [],
      loading: false,
    };
  },
  methods: {
    moment,
    load() {
      api
        .get(
          "/v1/kendali_kerja/pekerjaanController/getNotifikasi?id_user=" +
            this.$user.id
        )
        .then((r) => {
          this.data = r.data;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped lang="scss">
.tugas {
  padding: 20px;

  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    left: calc(50% - 240px);
    width: 440px;
    display: flex;
    gap: 10px;
    align-items: center;
    border-bottom: 1px solid #ccc;
    padding: 15px 20px;
    background: #fff;

    @media screen and (max-width: 768px) {
      left: 0;
      width: calc(100% - 40px);
    }

    h3 {
      margin: 0;
    }
    .icon {
      height: 26px;
      display: flex;
      align-items: center;
    }
  }

  .body {
    padding-top: 40px;
    padding-bottom: 100px;

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;

        div {
          display: flex;
          align-items: center;

          p {
            font-size: 14px;
            line-height: 22px;
            color: #555;

            b {
              color: #333;
            }
          }

          &:last-child {
            font-size: 13px;
            white-space: nowrap;
            color: #888;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notifikasi.vue